import React,{ Component } from "react";
import ReactPaginate from 'react-paginate';
import '../Pagination/paginate.css'
/*
 .pagination>.active>a,
.pagination>.active>a:focus,
.pagination>.active>a:hover,
.pagination>.active>span,
.pagination>.active>span:focus,
.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#3f51b5;border-color:#3f51b5}
 */
class Paginate extends Component
{
    handlePageClick = data => {
        let selected = data.selected + 1;
        this.props.setPage(selected);
      };
    render()
    {
        return(
        <div>
        <ReactPaginate
          forcePage={this.props.page-1}
          previousLabel={'<'}
          nextLabel={'>'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={this.props.data.count}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          />      
        </div>
        );
    }
}
export default Paginate;